















































import { Component, Prop, Vue } from 'vue-property-decorator'

@Component
export default class HeaderAdmin extends Vue {
  @Prop() private logo!: string;
  @Prop() private styleType!: string;
  @Prop() private search!: boolean;
  @Prop() private lang!: boolean;
  @Prop() private config!: boolean;
  @Prop() private links!: string[];
}
